<template>
  <VDialog v-model="dialog" max-width="450">
    <VCard style="overflow: auto">
      <VBtn absolute class="mt-1" icon style="right: 0" @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <v-card-title>{{ $t("confirmWithEimzo") }}</v-card-title>

      <VCardText>
        <CustomSelect
          v-model="select"
          :items="certs"
          :label="$t('selectKey')"
          class="user_input no-margin"
          custom-item
          item-text="CN"
          item-value="UID"
        >
          <template #item="{ item }">
            <VList dense>
              <VListItem dense style="min-height: 22px"
                ><span class="pr-1">{{ $t("eimzo.certificate") }} №: </span>
                {{ item.serialNumber }}
              </VListItem>
              <VListItem dense style="min-height: 22px"
                ><span class="pr-1">{{ $t("eimzo.stir") }}: </span>
                {{ item.TIN }}
                <span class="pl-2">{{ item.T }}</span></VListItem
              >
              <VListItem dense style="min-height: 22px"
                ><span class="pr-1"
                  >{{ $t("eimzo.fullName") }}: {{ item.CN }}
                </span></VListItem
              >
              <VListItem dense style="min-height: 22px"
                ><span class="pr-1">{{ $t("eimzo.organization") }}:</span>
                {{ item.O }}
              </VListItem>
              <VListItemSubtitle
                class="pl-4 pt-1"
                dense
                style="min-height: 22px"
                ><span class="font-weight-bold pr-1"
                  >{{ $t("eimzo.expiryDate") }}:</span
                >
                {{ item.validFrom | fullTimeParse }} -
                {{ item.validTo | fullTimeParse }}
              </VListItemSubtitle>
            </VList>
          </template>
        </CustomSelect>

        <VBtn
          class="mt-2 mb-3 primary rounded float-right white--text"
          icon
          @click="submit"
        >
          OK
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import { initModuleEimzo } from "@oybekmavlonov/e-imzo";

let eimzo = null;

export default {
  name: "E-imzoDialog",
  data() {
    return {
      dialog: false,
      certs: [],
      select: null,
      data: null,
      lastSignId: null,
    };
  },
  computed: {
    selectEImzoKey() {
      return this.certs.find((item) => item.UID === this.select);
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.select = null;
      }
    },
  },
  methods: {
    async submit() {
      const signHash = await this.getUserKey(this.data);
      if (signHash) {
        this.$emit("getToken", signHash);
        this.close();
        this.select = null;
      }
    },
    async getUserKey(data) {
      try {
        let key = this.selectEImzoKey;
        const { hash, id } = await eimzo.getHashESign(
          key,
          JSON.stringify(data),
          this.lastSignId
        );

        this.lastSignId = id;
        return hash;
      } catch (e) {
        return null;
      }
    },
    async open(data) {
      if (!data) {
        throw new Error(`Data should not be empty`);
      }
      try {
        if (!eimzo) {
          eimzo = await initModuleEimzo();
        }
        await eimzo.checkVersion();
        this.certs = await eimzo.listAllUserKeys();
        this.dialog = true;
        this.data = data;
      } catch (e) {
        const error = {
          message: "E-Imzo not installed",
        };
        this.setResponseError({ error: error });
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
